export default [
  {
    title: "control_ticket.titulo",
    fontIcon: "ticket",
    resource: "Control Ticket",
    action: "ver-control-ticket",
    children: [
      {
        title: "Transacciones",
        fontIcon: "exchange-alt",
        resource: "Control Ticket",
        action: "ver-control-ticket-transacciones",
        children: [
          {
            route: "control-ticket-transacciones-impresion-comedor",
            title: "control_ticket.transacciones.impresion.titulo",
            fontIcon: "print",
            resource: "Control Ticket",
            action: "ver-control-ticket-transacciones-impresion-comedor",
          }
        ]
      },
      {
        title: "Configuración",
        icon: "SettingsIcon",
        resource: "Control Ticket",
        action: "ver-control-ticket-configuracion",
        children: [
          {
            route: "control-ticket-configuacion-relojes",
            title: "control_ticket.configuracion.relojes.titulo",
            fontIcon: "print",
            resource: "Control Ticket",
            action: "ver-control-ticket-configuracion-relojes",
          }
        ]
      },
    ],
  }
]